import { render, staticRenderFns } from "./EntregaConfigModal.vue?vue&type=template&id=01c9f5e4&scoped=true"
import script from "./EntregaConfigModal.vue?vue&type=script&lang=js"
export * from "./EntregaConfigModal.vue?vue&type=script&lang=js"
import style0 from "./EntregaConfigModal.vue?vue&type=style&index=0&id=01c9f5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9f5e4",
  null
  
)

export default component.exports